import React, { useState, useEffect } from 'react';
import { SFuncModal } from 'shj-components'
import {
  Form,
  Button,
  Table,
  message
} from 'antd';

import { findCanVerifyApplyBillResponse } from '@/services/fmsServices'

export function modalAddOrSelectFn({ fns, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `核销单据选择`,
    width: 1000,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fns={fns} {...rest} />,
  });

  return dialog;
}
const ModalAddOrEditDom = ({ onClose, fns, ...rest }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [selectedRowsData, setSelectedRowsData] = useState([] as any[]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [dataSource, setDataSource] = useState([] as any[]);

  useEffect(() => {
    loadTable();
  }, []);

  const loadTable = () => {
    setAddOrEditFooterLoading(true);
    findCanVerifyApplyBillResponse({
      orderAccountId: rest.orderAccountId,
      verifyType: rest.sourceBillType === 'verifySourceTypeReceipt' ? rest.amount > 0 ? 'verifyTypePosReceipt':'verifyTypeNegReceipt' : rest.receivableAmount > 0 ? 'verifyTypePosReceiptApply':'verifyTypeNegReceiptApply',
      billId: rest.id
    }).then((response: any) => {
        const data = response?.canVerifyApplyBillDtlResponseList.map(item => ({
          ...item,
          key: item.sourceId,
        }));
        setDataSource(data);
        // setPagination({ current: pagination.current, pageSize: pagination.pageSize, total: response?.total });
        setAddOrEditFooterLoading(false);
      });
  };
  const columns = [
    { title: '单据类型', dataIndex: 'sourceBillTypeName', key: 'sourceBillType', width: 140, },
    { title: '单据号', dataIndex: 'sourceCode', key: 'sourceCode', width: 140, },
    { title: '交易/收款类型', dataIndex: 'sourceTypeName', key: 'sourceType', width: 140, },
    { title: '可核销金额', dataIndex: 'canVerifyAmount', key: 'canVerifyAmount', width: 140, },
  ];
  const rowSelection = {
    onChange: (selectedRows: any[], selectedRowKeys: any[]) => {
      console.log(selectedRows, selectedRowKeys);
      setSelectedRowsData(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: rest.datas.some(data => data.sourceId === record.sourceId),
    }),
  };
  const tableChange = () => {
    if(selectedRowsData && selectedRowsData.length !== 0){
      onClose();
      fns && fns(selectedRowsData);
    }else{
      message.error('至少选中一条数据确认')
    }
  };
  return (
    <div style={{ padding: '20px' }}>
      <Table
        rowKey="sourceId"
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        loading={addOrEditFooterLoading}
        pagination={false}
        columns={columns}
        size="small"
        dataSource={dataSource}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <Button
          type="primary"
          style={{ margin: '0 8px', float: 'right' }}
          onClick={tableChange}
          loading={addOrEditFooterLoading}
        >
          确认
        </Button>
      </div>
    </div>
  );
};
